import React from 'react'
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './ApplicationInsights';
import styled from 'styled-components'

import { GlobalStyle } from '../global-styles'
import Counter from '../Counter/Counter'

import logoSquare from './logo_square.svg'

import 'url-search-params-polyfill'

const App: React.FC = () => {
    // TODO: Set different designs based on URL

    const urlParams = new URLSearchParams(window.location.search)
    const station = urlParams.get('station') || ''

    return (
        <AppWrapper>
            <GlobalStyle />
            <Counter station={station} />
            <Logo src={logoSquare} alt="Arlanda Express" />
        </AppWrapper>
    )
}

export default withAITracking(reactPlugin, App)

const AppWrapper = styled.div``

const Logo = styled.img`
    position: absolute;
    bottom: 2vh;
    right: 2vh;
    width: 12vw;

    @media (orientation: portrait) {
        width: 12vh;
    }
`
